import { render, staticRenderFns } from "./CaseDemo.vue?vue&type=template&id=f4ed3156&scoped=true"
import script from "./CaseDemo.vue?vue&type=script&lang=js"
export * from "./CaseDemo.vue?vue&type=script&lang=js"
import style0 from "./CaseDemo.vue?vue&type=style&index=0&id=f4ed3156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ed3156",
  null
  
)

export default component.exports